import callPersonnelApi from './personnelService';
import callBackendApi from '../backendService/backendService';
import { buildQueryUrlFromObject } from '../../helper/buildQueryUrlFromObject';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;

export const getReservation = (statusInfo) => callPersonnelApi({
    method: 'POST',
    endpoint: `${basePath}/reservation/get-reservation`,
    body: statusInfo
});

export const getReservationTypeList = () => callBackendApi({
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    endpoint: `${basePath}/sp/reservation-types`
});

export const getReservationTimeList = (formData) => callBackendApi({
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    endpoint: `${basePath}/sp/reservation-period?${buildQueryUrlFromObject(formData)}`
});

export const updateReservation = (updateInfo) => callPersonnelApi({
    method: 'POST',
    endpoint: `${basePath}/reservation/update`,
    body: updateInfo
});

export const deleteApi = (deleteInfo) => callPersonnelApi({
    method: 'POST',
    endpoint: `${basePath}/reservation/delete`,
    body: deleteInfo
});

export const check = (checkInfo) => callPersonnelApi({
    method: 'POST',
    endpoint: `${basePath}/reservation/check`,
    body: checkInfo
});

export const success = (successInfo) => callPersonnelApi({
    method: 'POST',
    endpoint: `${basePath}/reservation/success`,
    body: successInfo
});

export const getReservationCalendarInfo = (formData) => callPersonnelApi({
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    endpoint: `${basePath}/reservation/calendar?${buildQueryUrlFromObject(formData)}`
});

export const getReservationStores = () => callBackendApi({
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    endpoint: `${basePath}/reservation-store`
});

export const getCustomerReservationTypes = () => callBackendApi({
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    endpoint: `${basePath}/member/reservation-types`
});

export const getCustomerReservationTimeList = (formData) => callBackendApi({
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    endpoint: `${basePath}/member/reservation-period?${buildQueryUrlFromObject(formData)}`
});

export const storeCustomerReservation = (sendInfo) => callBackendApi({
    method: 'POST',
    endpoint: `${basePath}/member/reservations`,
    body: sendInfo
});

export const getAssignSpDropdown = (formData) => callPersonnelApi({
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    endpoint: `${basePath}/reservation/assign-sp-dropdown?${buildQueryUrlFromObject(formData)}`
});

export const assignReservation = (formData) => callPersonnelApi({
    method: 'POST',
    endpoint: `${basePath}/reservation/assign-reservation`,
    body: formData
});

export const backReservation = (reservation_id) => callPersonnelApi({
    method: 'POST',
    endpoint: `${basePath}/reservation/back`,
    body: reservation_id
});

// 取得Event活動預約時間
export const getMemberEventReservationTimeList = (formData) => callPersonnelApi({
    method: 'GET',
    endpoint: `${basePath}/activity/options/activity?${formData}`,
    body: formData
});

// 儲存Event活動預約
export const storeEventReservation = (formData) => callPersonnelApi({
    method: 'POST',
    endpoint: `${basePath}/activity/reservation/member`,
    body: formData
});

// 取得Event活動專賣店
export const getEventStoreDropdown = (formData) => callPersonnelApi({
    method: 'GET',
    endpoint: `${basePath}/activity/options/activity-store/${formData.id}`,
    body: formData
});
